
<template>
    <div class="container contentBox bgfff mt20">
        <div class=" ml10 mr10">
            <!-- <prowerSetting @selectStation="selectStation" /> -->
            <div class=" ">
                <div class="">
                 <span class="fz14 c6">{{$t('alarmData.monitorList')}}：</span>
                  <el-select v-model="monitorId" clearable filterable :placeholder="$t('dataAnalysis.pleCho')">
                    <el-option
                        v-for="(item,index) in typeList"
                        :key="index"
                        :label="item.monitorName"
                        :value="item.streamId">
                        </el-option>
                    </el-select>
                 
                    <span class="fz14 c6 ml20">{{$t('alarmSetting.airCode')}}：</span>
                    <el-input v-model="devNumber" placeholder style="width:15%"></el-input>
                    <span class="fz14 c6 ml20">{{$t('alarmSetting.statusList')}}：</span>
                  <el-select v-model="handleFlag" clearable filterable :placeholder="$t('dataAnalysis.pleCho')">
                    <el-option
                        v-for="(item,index) in flaglist"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="search()">{{$t('tagsView.search')}}</el-button>
                  <el-button type="primary" size="small" class="ml10" icon="el-icon-refresh" @click="refresh()">{{$t('dataAnalysis.reset')}}</el-button>
              </div>
            </div>
        </div>
         <!-- <input
                type="text"
                placeholder="开始日期"
                class="layDateInput"
                id="orderStartTime"
                v-model="startdate"
            /> -->
        <div class="mt10 ml10 mr10">
            <el-table :data="tableData" border style="width: 100%" >
                
                <el-table-column prop="projectName" align="center" :label="$t('manipulation.devName')"></el-table-column>
            
                <el-table-column prop="devNumber" align="center" :label="$t('alarmSetting.airCode')"></el-table-column>
                <el-table-column prop="alarmName" align="center" :label="$t('alarmData.dataName')"></el-table-column>
                <el-table-column prop="alarmContent" align="center" :label="$t('alarmSetting.alarmContent')"></el-table-column>
                <el-table-column prop="time" align="center" :label="$t('alarmData.curAlarmTime')"></el-table-column>
                <!-- <el-table-column prop="alarmLevelName" align="center" label="报警等级"></el-table-column> -->
                <el-table-column prop="monitorValue" align="center" :label="$t('alarmData.dataValue')"></el-table-column>
                <el-table-column prop="handleFlag" align="center" :label="$t('alarmData.status')">
                    <template slot-scope="scope">
                        {{scope.row.handleFlag*1 ? $t('alarmData.processed') : $t('alarmData.notProcessed')}}
                    </template>
                </el-table-column>
                <el-table-column prop="handleTime" align="center" :label="$t('alarmData.processTime')"></el-table-column>
                <el-table-column prop="solution" align="center" :label="$t('alarmData.copMethod')">
                    <!-- <template slot-scope="scope">
                       <div @click="seeMore(scope.row)" class="c0b9 hand"> 点击查看 </div>
                    </template> -->
                </el-table-column>
                <el-table-column :label="$t('realdetile.opera')" width="200" align="center">
                    <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-view" @click="viewHandle(scope.row)">{{$t('alarmData.lookHistory')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align:end;margin-top:12px">
                        <el-pagination
                           @current-change="handleCurrentChange1"
                            :current-page.sync="currentPage"
                            :page-size="10"
                            layout="total, prev, pager, next"
                            :total="totals">
                        </el-pagination>
                </div>
        </div>
        <div class="customerDialog"  v-show="dialogStationVisible">
            <div class="dialogBg" @click="handleClose"></div>
            <div class="dialogContent">
                <div class="dialogTitle">
                    {{title}} 
                    <i class="el-icon-circle-close closeIcon" @click="handleClose"></i>
                </div>
                <div class="mt20 pl40"> {{$t('alarmData.choiceDate')}}:
                    <!-- <input type="text"  placeholder="开始日期"  class="layDateInput" id="orderStartTime"  v-model="startdate"  /> 至 <input
                        type="text"
                        placeholder="结束日期"
                        class="layDateInput"
                        id="orderEndTime"
                        v-model="enddate"
                    />  -->
            <el-date-picker
                v-model="installTime"
                type="daterange"
                :range-separator="$t('sendCmdLog.arrive')"
                :start-placeholder="$t('alarmData.startDate')"
                :end-placeholder="$t('alarmData.endDate')">
                </el-date-picker>
             <el-button type="primary" @click="searchHistory" class="ml20">{{$t('dataAnalysis.inquire')}}</el-button></div>
                <!-- <div id="echartHistory"  v-loading="loading"></div> -->
                <div style="margin-top:20px">
                     <el-table :data="tableData1" border style="width: 100%" >
                        <el-table-column prop="index" align="center" :label="$t('realdetile.serNum')"></el-table-column>
                        <el-table-column prop="alarmContent" align="center" :label="$t('alarmData.fail')"></el-table-column>
                        <el-table-column prop="monitorValue" align="center" :label="$t('alarmData.numericValue')"></el-table-column>
                        <el-table-column prop="time" align="center" :label="$t('dataAnalysis.time')"></el-table-column>
                       
                    </el-table>
                </div>
                 <div class="paginBox mt10 flex between">
                        <el-pagination
                        @size-change="handleSizeChange"
                        @prev-click ="handleCurrentChange"
                        @next-click ="handleCurrentChange"
                        :current-page="current"
                        :page-sizes="[10]"
                        :page-size="size"
                       
                        layout="total, sizes"
                        :total="total">
                        </el-pagination></div>
                    <div  class="dialog-footer mt20 " style="margin-bottom:20px">
                        <el-button class="button--cancel" @click="handleClose">{{$t('manipulation.cancel')}}</el-button>
                        <el-button type="primary" @click="handleClose">{{$t('manipulation.sure')}}</el-button>
                    </div>
            </div>
        </div>
        <div> 
            
            </div>
        <!-- <el-dialog :title="title" :visible="dialogStationVisible" @close="handleClose" width="800px" center>
             <div>  选择日期：
                

             <input
                type="text"
                placeholder="结束日期"
                class="layDateInput"
                id="orderEndTime"
                v-model="enddate"
            />
                
                <el-button type="primary" @click="searchHistory" class="ml20">查询</el-button></div> 
            <div id="echartHistory"  v-loading="loading"></div>
            <div class="paginBox mt10 flex between">
            <el-pagination
            @size-change="handleSizeChange"
            @prev-click ="handleCurrentChange"
            @next-click ="handleCurrentChange"
            :current-page="current"
            :page-sizes="[50, 100, 150]"
            :page-size="size"
            prev-text = '上一页'
            next-text = '下一页'
            layout="total, sizes, prev, next"
            :total=total>
            </el-pagination></div>
            <div slot="footer" class="dialog-footer">
                <el-button class="button--cancel" @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleClose">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
// import prowerSetting from '@/components/power/prowerSetting';
import { mapGetters } from 'vuex';
import { getAlarmData,getMonitorList,getAlarmDetail,getHistory,alarmDateList } from '@/api/deviceOverview/alarm';
import {dictList} from '@/api/deviceOverview/file';
const moment = require('moment');
export default {
    name: 'alarmData',
    data() {
        return {
            searchVal:'',
            gatewayId:'',
            tableData: [],
            variateOptions: [],
            installTime: [],
            monitorId: '',
            current:1,
            size: 10,
            total: 0,
            title:this.$t('manipulation.sawBack'),
            dialogStationVisible: false,
            unit: '',
            curRow:{},
            loading: false,
            startdate: '',
            enddate:'',
            currentPage:1,
            totals:0,
            tableData1:[],
            typeList:[],
            flaglist:[
                {label:this.$t('alarmData.notProcessed'),value:'0'},{label:this.$t('alarmData.processed'),value:'1'},
            ],
            handleFlag:'',
            devNumber:''
        };
    },
    created() {
       this.gatewayId = this.stationObj.gatewayId
       this.startdate = moment().startOf('month').format('YYYY-MM-DD')
       this.enddate = moment().format('YYYY-MM-DD')
       this.queryAlarmData()
    //    this.getdictList()
       this.getMonitorList()
    },
    components: {
        // prowerSetting
    },
    computed: {
      ...mapGetters(["stationObj"])
    },
    methods: {
        handleCurrentChange1(val){
            this.currentPage = val
            this.queryAlarmData()
        },
        // 监控点列表
        getMonitorList(){
            getMonitorList().then(res=>{
                if(res.data.code==200){
                  
                     this.typeList = res.data.data
                }
            })
        },
         getdictList(){
            // 空调
            dictList({code:"device_model"}).then(res=>{
                if(res.data.code===200){
              
                    this.typeList = res.data.data[0].children
                }
            })
           
        },
        seeMore (row) {
            console.log(row,'---')
        },
        init(){
            this.installTime = []
        },
        handleClose () {
            this.init()
            this.dialogStationVisible = false
        },
        handleSizeChange(val) {
            console.log(`this.$t('alarmData.everyPage') ${val} this.$t('alarmData.strip')`);
            this.size = val
            this.current = 1
            this.searchHistory(this.curRow)
        },
        handleCurrentChange(val) {
            console.log(`this.$t('alarmData.currentPage') ${val}`);
            this.current = val
            this.searchHistory(this.curRow)
        },
        queryAlarmDateList () {
            let obj ={}
            let row = this.curRow
            let that= this
            alarmDateList({alarmId:row.alarmId}).then(res=> {
                if (res.data.code === 200) {
                    console.log(res.data.data)
                    for(let i =0 ;i <res.data.data.length;i++){
                        obj[res.data.data[i]] = ''
                    }
                    laydate.render({
                        elem: '#orderStartTime',
                        mark: obj,
                        zIndex: 99999999,
                        trigger: 'click',
                        done: function(value, date) {
                            that.startdate = value
                        }
                    });

                    laydate.render({
                        elem: '#orderEndTime',
                        zIndex: 99999999,
                        mark: obj,
                        type: 'date', 
                        trigger: 'click',
                        done: function(value, date) {
                            that.enddate = value
                        }
                    });
                } else {
                    this.$message.error(res.data.msg);
                    return;
                }
                
            })
        },
        searchHistory (row) {
            this.loading = true
            let obj ={
                alarmId: this.curRow.alarmId,
                streamId:this.curRow.streamId,
                onenetId:this.curRow.onenetId,
                devCode:this.curRow.devCode,
                current: this.current,
                size:this.size,
            }
            // this.queryAlarmDateList()
            if (this.installTime&&this.installTime.length>0) {
                obj.beginTime =  moment(this.installTime[0]).format('YYYY-MM-DD')
                obj.endTime = moment(this.installTime[1]).format('YYYY-MM-DD')
            }
            getHistory(obj).then(res=>{
                this.loading = false
                if (res.data.code === 200) {
                    console.log(res.data.data)
                    res.data.data.records.map((item,index)=>{
                       item.index = index +1
                   })
                    this.tableData1 = res.data.data.records
                    // let xAxisAry = [],sAry =[]
                    // data.forEach(item=>{
                    //     xAxisAry.push(item.time)
                    //     sAry.push(item.value)
                    // })
                    this.total = res.data.data.total
                    // this.rendCharts(xAxisAry,sAry)
                } else {
                    this.$message.error(res.data.msg);
                    return;
                }
            })
        },
        viewHandle (row) {
            this.unit = row.unit
            this.curRow= row
            this.title =  row.alarmName // + row.alarmLevelName
            this.dialogStationVisible = true
            this.searchHistory(row)
        },
        // rendOptions (data) {
        //     let ary =[]
        //     data.map(item=>{
        //         let obj = {}
        //         obj.monitorName = item.alarmName
        //         obj.streamId = item.streamId
        //         ary.push(obj)
        //     })
        //     this.variateOptions = ary
        // },
        // selectStation (data) {
        //     console.log(data,'===daata')
        //     this.gatewayId = data.gatewayId
        //     this.queryAlarmData()
        // },
        getPage () {

        },
        drawBarChart(id, options) {
            let myChart = echarts.init(document.getElementById(id));
            // 使用 aidState做填充，fakeState显示小线条
            myChart.showLoading({
                text: this.$t('alarmData.loading')+"..."
            });
            myChart.hideLoading();
            myChart.setOption(options, (window.onresize = myChart.resize));
        },
        rendCharts (xAxisAry, seriesAry) {
            let options = {
                 xAxis: {
                    type: 'category',
                    data: xAxisAry
                },
                grid: {  
                    left: '4%',  
                    right: '4%',  
                    bottom: '6%',  
                    containLabel: true  
                },
                tooltip: {
                    trigger: 'axis'
                },
                yAxis: {
                    type: 'value',
                     name: this.$t('alarmData.loading')+":"+this.unit,
                     minInterval:1
                },
                series: [{
                    data: seriesAry,
                    type: 'line'
                }]
            };
            this.drawBarChart('echartHistory', options)
        },
        seeMore (row){
           
            getAlarmDetail({id: row.alarmId}).then(res=>{
                if (res.data.code === 200) {
                    this.$alert(res.data.data.solution||this.$t('dataAnalysis.none'), '', {
                        confirmButtonText: this.$t('manipulation.sure')
                    });
                } else {
                    this.$message.error(res.data.msg);
                    return;
                }
            })
            
        },
        search () {
            this.currentPage = 1
            this.queryAlarmData()
        },
        refresh(){
            this.monitorId= ''
            this.handleFlag = ''
            this.devNumber= ''
            this.currentPage = 1
            this.queryAlarmData()
        },
        queryAlarmData () {
            const {current, size, monitorId,handleFlag,devNumber, gatewayId} = this
            // monitorId,
            getAlarmData({streamId:monitorId,handleFlag,devNumber, gatewayId,size:10,current:this.currentPage}).then(res=>{
               if (res.data.code === 200) {
                   res.data.data.records.map((item,index)=>{
                       item.index = index +1
                   })
                   this.tableData = res.data.data.records
                   this.currentPage = res.data.data.current
                   this.totals = res.data.data.total
                //    this.rendOptions(this.tableData)
                } else {
                    this.$message.error(res.data.msg);
                    return;
                } 
            })
        }
    },
    mounted() {
        let that =  this
        
        
    }
};
</script>

<style scoped lang='scss'>
.contentBox{height: calc(100% - 40px);overflow-y: auto;}
    .handle-input{width: 200px;}
    #echartHistory{width:80%;height:calc(100% - 220px);margin: 0 auto;;}
    .maxHeight{height: calc(100% - 100px);}
    .paginBox{
    .el-pagination{width: 80%;margin: 0 auto;}
    .btn-prev,.btn-next{border: 1px solid #ccc;}
    }
    .layDateInput{width: 160px;margin:0 10px;}
    .customerDialog{
        position: relative;
        .dialogBg{position: fixed;left:0;top:0;z-index:11;width:100%;height: 100%;background: rgba($color: #000000, $alpha: 0.8);;}
        .dialogContent{width: 66%;background: #fff;box-sizing: border-box;position: fixed;left:0;right:0;z-index: 12;top:10%;left:17%;border-radius:10px;;}
        .dialogTitle{
            border-radius: 10px 10px 0 0;padding: 20px 20px 10px;background: #01ADA8;text-align: center;color: #fff;position: relative;
            .closeIcon{position: absolute;right: 12px;top:12px;font-size:30px;color: #fff;font-weight: 400;}
        }
        
    }
</style>
